export enum RequisitionStatus {
	Draft = "Draft",
	Approved = "Approved",
	ChangeRequested = "Change Requested",
	Reviewed = "Reviewed",
	Rejected = "Rejected",
	TaskCompleteRequest = "Task Complete Request",
	RequestForApproval = "Request For Approval",
	Deleted = "Deleted",
	Recalled = "Recalled",
	OnHold = "On Hold",
	SubmittedForBudgetApproval = "Submitted For Budget Approval",
	Converted = "Converted",
	PartiallyConverted = "Partially Converted",
}

export enum RequisitionConfirmationType {
	Approve = "approve",
	TaskCompletion = "task-complete",
	ChangeRequest = "change-request",
	Delegation = "delegate",
	Rejection = "reject",
	Recall = "recall",
}

export enum RequisitionActionType {
	Edit = "edit",
	Delete = "delete",
}

export enum ReqConversionToBidActionType {
	Convert = "convert",
}
